import React, { useEffect, useState } from 'react';
// import MenuItem from '../components/MenuItem';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../App.css';
// import ReactPlayer from 'react-player';
// import { Post } from '../core/lib/types';
import Auth from '../core/services/auth';
import { ToastContainer } from 'react-toastify';
import { getVideoThumb } from '../core/lib/utils';

import  IconBackComponent from '../components/IconBackComponent';
// import  IconLikeComponent from '../components/IconLikeComponent';
// import  IconPinComponent from '../components/IconPinComponent';
// import  IconShareComponent from '../components/IconShareComponent';
// import  IconMoreComponent from '../components/IconMoreComponent';
import ReactTimeAgo from 'react-time-ago'
import Avatar from 'react-avatar';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import _ from 'lodash';
import Marquee from "react-fast-marquee";

import AutoSizer from "react-virtualized-auto-sizer";
// import { FixedSizeList as List } from "react-window";
 
function PostView() {
    
    const navigate = useNavigate();
    const { state } = useLocation();
    // const [ data, setData ] = useState([])

    const [ post, setPost ] = useState(state ? state.post : {
                            key:'',
                            caption:'',
                            media: {
                              type: '',
                              url: ''
                            },
                            user: {
                              _id: '',
                              username: '',
                              email: '',
                              accountType: '',
                              emailVerified: null,
                              deleted: null,
                              createdAt: '',
                              updatedAt: '',
                              __v: 0,
                              id: ''
                            },
                            profile: {
                              profileImage: {
                                publicId: '',
                                type: '',
                                url: ''
                              },
                              _id: '',
                              userId: '',
                              deleted: null,
                              createdAt: '',
                              updatedAt: '',
                              __v: 0,
                              firstName: '',
                              gender: '',
                              lastName: '',
                              phone: '',
                              id: ''
                            },
                            location:{
                              name: '',
                              coordinates: [0, 0]
                            },
                            id: '',
                            createdAt: null,
                            posts: [],
                            likedBy: [],
                            likes: 0,
                            pinnedBy: [],
    })
    const [ mute, setMute ] = useState(Auth.getMuted() !== "undefined" ? Auth.getMuted() === 'true' ? true : false : false)

    // console.log(useParams())
    const params = useParams()

    useEffect(()=>{

      if (!state &&  !_.isEmpty(params) ) {
        //
        Auth.api.get('/posts/'+params.id).then(res=>{
          //
          setPost(res.data.data)
          console.log(res.data.data)
        })
  
      } 
      else if (state) {

      }
      else {
        //
        navigate('/')
        return;
      }

    }, [navigate, params, setPost, state])
    

    const unMute = () => {
      //
      if (mute) {
        setMute(false)

        Auth.setMuted('false')
      } else {
        setMute(true)
        Auth.setMuted('true')
      }
    }
    
    const sharePost = async (id: string, caption: string) => {

      if (_.isEmpty(Auth.getUser())) {
        navigate('/login')
        return;
      } 

      const shareData = {
        title: `Wherespoppin - ${caption}`,
        text: `${caption}`,
        url: `https://wherespoppin.app/post/${id}`,
      };
      //
      await navigator.share(shareData);
    }

    const [ open, setOpen ] = useState(false)

    // console.log(post)

    const likePost = (id: string) => {
      
      if (_.isEmpty(Auth.getUser())) {
        navigate('/login')
        return;
      } 

      Auth.api.get("/posts/like/"+id).then(res=>{

        // toast.success(res.data.message, {
        //   position: "top-center",
        // });
        const data = JSON.parse(JSON.stringify(res.data.data))
        data.pinnedBy = data.pinnedBy ? data.pinnedBy : []
        data.user = state.post.user
        data.profile = state.post.profile

        setPost(data)
        // post.likedBy = res.data.data.likedBy
        // post.likes =  res.data.data.likedBy

      }).catch(err=>{
        
        console.log(err)
        
          // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          //   position: "top-center",
          // });
      })

    }

    const pinPost = (id: string) => {

      if (_.isEmpty(Auth.getUser())) {
        navigate('/login')
        return;
      } 
      //
      Auth.api.post("/pins/", { postId: id, userId: Auth.getUser()._id }).then(res=>{

        // toast.success(res.data.message, {
        //   position: "top-center",
        // });
        // console.log(res.data.data)
        Auth.api.get('/posts/'+id).then(res=>{
          
          const data = JSON.parse(JSON.stringify(res.data.data))

          data.pinnedBy = data.pinnedBy ? data.pinnedBy : []
          data.user = state.post.user
          data.profile = state.post.profile
          // 
          
          setPost(data)
        })
        

      }).catch(err=>{
        
        console.log(err)
        
          // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          //   position: "top-center",
          // });
      })
    }

    const deletePost = (id: any) => {
      
      if (_.isEmpty(Auth.getUser())) {
        navigate('/login')
        return;
      } 

      Auth.api.delete("/posts/"+id).then(res=>{

        // toast.success(res.data.message, {
        //   position: "top-center",
        // });
        
        // console.log(res.data.data)
        navigate(-1)


      }).catch(err=>{
        
          console.log(err)
        
          // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          //   position: "top-center",
          // });
      })
    }

    // const _posts = posts.slice( posts.findIndex((ps: { _id: any; }) =>ps._id === post.id) )

    // const postsItems = _posts.map(
    //   // _story => <StoryComponent story={_story} />
    //   // _story => <li> {_story.caption} </li>
    //   (_post: Post) => 
    //     <section className='h-screen'>
    //         <IconBackComponent />
    //         <div className='absolute end-6 bottom-6 space-y-3 flex flex-col mb-20'>
    //           <IconLikeComponent />
    //           <IconPinComponent />
    //           <IconShareComponent />
    //           <IconMoreComponent />
    //         </div>
    //         <div className="h-screen bg-black">
    //         {_post.media.type === 'image' ?
            
    //               <img alt={_post.caption} className='h-screen object-cover' src={_post.media.url}></img>
    //           :
    //               _post.media.type === 'video' ?

    //               // <ReactPlayer  height={"100vh"} playing={true} style={{ objectFit: 'cover' }} url={post.media.url} className="p-0 m-0" >
    //               // </ReactPlayer>
    //               <video loop autoPlay={true}  style={{ objectFit: 'cover' }} className="h-screen object-cover"> 
    //                   <source src={_post.media.url} type='video/mp4'></source>
    //                   <source src={_post.media.url} type='video/ogg'></source>
    //               </video>
                  
    //           :

    //           ''
    //         }
              
    //         </div>
    //       </section>
        
    // )
    

    return (
      <div>
        {/* {postsItems} */}
        <section className='h-screen'>
          <ToastContainer />
            <IconBackComponent />
            <div className='absolute end-6 bottom-16 space-y-3 flex flex-col mb-20 z-20'>
              {/* like */}
              <button className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:text-red-500 duration-300' onClick={e=>likePost(post.id)}>
                  <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                    {/* <button className="items-center"> */}
                    { post.likedBy.includes(Auth.getUser()._id) ?
                    
                    <svg className="w-5 h-5 transition ease-in-out delay-150 hover:scale-110 hover:text-red-500 duration-300 text-red-500" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="FavoriteIcon"><path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"></path></svg>
                    :
                    <svg className="w-5 h-5 transition ease-in-out delay-150 hover:scale-110 hover:text-red-500 duration-300" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="FavoriteBorderOutlinedIcon"><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3m-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05"></path></svg>
                    }
                    {/* </button> */}
                </div>
              </button>
              {/* pin */}
              <span style={{marginTop: "0"}} className='pt-2 text-center text-white text-xs font-medium'>{post.likes}</span>
              <button className='' onClick={e=>pinPost(post.id)}>
                <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                  { post.pinnedBy.includes(Auth.getUser()._id) ?
                  <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BookmarkIcon"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2"></path></svg>
                  :
                  <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BookmarkBorderOutlinedIcon"><path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2m0 15-5-2.18L7 18V5h10z"></path></svg>
                  }
                </div>
              </button>
              {/* <IconShareComponent /> */}
              <button onClick={e=> sharePost(post.id, post.caption)}>
                <div style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                    <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="IosShareOutlinedIcon"><path d="m16 5-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2"></path></svg>
                </div>
              </button>

              <button onClick={e=>setOpen(true)}>
                <div style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                    <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MoreHorizOutlinedIcon"><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"></path></svg>
                </div>
              </button>
            </div>
            <div className='flex flex-col absolute bottom-9 space-y-2 left-6 z-30'>
              <div className='flex flex-row items-center space-y-1 relative'>
                  <NavLink to={Auth.getUser()._id === post.user._id ? '/profile' : '/user-profile'} state={{ user: { _id: post.user._id, username: post.user.username, profile: post.profile } }}>
                    {(post.profile.profileImage) &&
                                    
                      <div style={{width:'55px', height: '55px'}} className="border bg-gray-100 border-slate-400 rounded-full">
                          <div className="bg-white block rounded-full  hover:-rotate-6 transform transition">
                                <img alt='profile' className='rounded-full object-cover aspect-square p-0.5' src={post.profile.profileImage.url}/>
                          </div>
                      </div>
                                    
                    }
                    { !(post.profile.profileImage) &&
                        <Avatar round={true} size='55' name={post.profile.firstName+' '+post.profile.lastName} />
                    }
                  </NavLink>
                  <div className='ml-4 text-left  '>
                      <h2 className='text-md font-bold mb-0 text-white pb-0'>{post.user.username }</h2>
                      <p className='text-sm text-gray-500 text-white mb-0 pb-0'>
                        <ReactTimeAgo date={new Date(post.createdAt)} locale="en" />
                      </p>
                  </div>
                </div>
                
                {post.location.name ?
                  <div>
                    <p className='text-sm text-white text-left px-1 pb-1.5'>{post.caption}</p>
                    {post.location.name.length > 30 ?

                      <div className='text-white flex justify-left align-center text-xs p-1 text-left px-2 bg-gray-500/80 rounded-full max-w-64'>
                        <svg className="w-9 flex align-self-center mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MyLocationIcon"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"></path></svg>

                        {/* <svg className="w-4 h-4 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LocationOnIcon"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path></svg> */}

                        <span className='pr-2 flex align-self-center py-1'><Marquee>{post.location.name}</Marquee></span>
                      </div>

                      : 
                      
                      <div className='text-white flex justify-left align-center text-xs p-1 text-left px-2 bg-gray-500/80 rounded-full'>
                        <svg className="w-4 flex align-self-center mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MyLocationIcon"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"></path></svg>

                        {/* <svg className="w-4 h-4 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LocationOnIcon"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path></svg> */}
                        <span className='pr-2 flex align-self-center py-0.5'>{post.location.name}</span>
                        
                        
                      </div>
                    }
                    
                  </div>
                  
                  : 
                  <div>
                    <p className='text-sm text-white text-left px-1 pb-1.5'>{post.caption}</p>
                  </div>
                  }
            </div>
            <AutoSizer>
              {({ height, width }: any ) => (
                <div onClick={e=>unMute()} onDoubleClick={e=>pinPost(post.id)} style={{width: width, height: height}} className="h-screen- bg-black-">
                {post.media.type === 'image' ?
                
                      <img alt={post.caption} className='h-screen object-cover' src={post.media.url}></img>
                  :
                      post.media.type === 'video' ?

                      
                      <video poster={getVideoThumb(post.media.url)} muted={mute} playsInline={true} loop autoPlay={true}  style={{ objectFit: 'cover' }} className="h-screen object-cover"> 
                          {/* <source src={post.media.url+'#t=0.001'} type='video/mp4'></source>
                          <source src={post.media.url+'#t=0.001'} type='video/ogg'></source> */}
                      </video>
                      
                  :

                  ''
                }
                
              </div>
            )}
            </AutoSizer>
            <Dialog open={open} onClose={setOpen} className="relative z-30">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <div className="w- text-gray-900 bg-white rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white p-6">
                     
                      {post.user._id === Auth.getUser()._id ?
                        <button onClick={e=>deletePost(post.id)} type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-t-lg  bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                          <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteIcon"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"></path></svg>
                          {/* <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ReportGmailerrorredIcon"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"></path><path d="M11 7h2v6h-2zm0 8h2v2h-2z"></path></svg> */}
                                <p className='font-medium text-xs'>Delete post</p>
                                          
                        </button>
                        : ''
                      }
                      <button type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                        
                        <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ReportGmailerrorredIcon"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"></path><path d="M11 7h2v6h-2zm0 8h2v2h-2z"></path></svg>
                              <p className='font-medium text-xs'>Report post</p>
                                        
                      </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
          </section>
        </div>
    );
  }
  
  export default PostView;
  

